import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Redirect, useHistory, useParams } from "react-router-dom";

import { LoadingSpinner } from "@mapmycustomers/ui";

import MmcNotificationAction from "@app/enum/MmcNotificationAction";
import Path from "@app/enum/Path";
import {
  clickOnNotification,
  fetchNotification,
  fetchNotifications,
  showNotifications,
} from "@app/store/notification/actions";
import MmcNotification from "@app/types/MmcNotification";

interface Props {
  clickOnNotification: typeof clickOnNotification;
  fetchNotification: typeof fetchNotification.request;
  fetchNotifications: typeof fetchNotifications.request;
  showNotifications: typeof showNotifications;
}

const Notifications: React.FC<Props> = ({
  clickOnNotification,
  fetchNotification,
  fetchNotifications,
  showNotifications,
}) => {
  const { notificationId } = useParams<{ notificationId?: MmcNotification["id"] }>();
  const history = useHistory();

  useEffect(() => {
    if (notificationId) {
      fetchNotification({
        id: notificationId,
        callback: (notification) => {
          clickOnNotification({ notification });
          if (
            notification.entity?.length === 1 &&
            ![MmcNotificationAction.FOLDER_SHARED, MmcNotificationAction.RESOURCE_SHARED].includes(
              notification.action
            )
          ) {
            history.push(Path.DASHBOARD);
          }
        },
      });
    } else {
      showNotifications();
      fetchNotifications({ onlyMentions: false });
    }
  }, [
    clickOnNotification,
    fetchNotification,
    fetchNotifications,
    history,
    notificationId,
    showNotifications,
  ]);

  if (notificationId) {
    return <LoadingSpinner />;
  }
  return <Redirect to={Path.DASHBOARD} />;
};

const mapDispatchToProps = {
  clickOnNotification,
  fetchNotification: fetchNotification.request,
  fetchNotifications: fetchNotifications.request,
  showNotifications,
};

export default connect(null, mapDispatchToProps)(Notifications);
